import styled from "@emotion/styled";

const Form = styled.form`
  &.full-width {
    width: 100%;
  }

  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${({ theme }) => theme.space.space16};
`;

export { Form };
